import React from 'react'
import 'react-slideshow-image/dist/styles.css'
import { Fade } from 'react-slideshow-image'
import {
  toPlainText,
  isBottom,
  isBrowser,
  fullyInViewport,
  buildSliderSrcSetUrl,
} from '../lib/helpers'
import MouseTooltip from 'react-sticky-mouse-tooltip'
import ArrowNext from '../images/icons/arrow-next.svg'
import InfoI from '../images/icons/info-i.svg'
import PortableText from '../components/portableText'
import classNames from 'classnames'
import Open from '../images/icons/open.svg'
import Play from '../images/icons/play.svg'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { isMobile } from 'react-device-detect'
import SliderVideo from '../components/slider-video'
import { Link } from 'gatsby'
import SliderImg from './slider-img'
import AudioPlayer from './audio-player'

class GallerySlider extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      innerW: null,
      innerH: null,
      firstImageWidth: null,
      isMouseOverImage: false,
      isMouseOverLink: false,
      isMouseTooltipVisible: null,
      tooltipArrowDirection: 'right',
      isArtistSliderIn: false,
      headerSliderTogglePostition: 'bottom',
      artistSliderTogglePosition: 'top',
      isHeaderSliderInfoReady: false,
      isHeaderSliderScrolled: false,
      isArtistSliderScrolled: false,
      isPopupInfoVisible: false,
      slideIndex: 0,
      imgWidth: 2400,
      isSlideInfoIn: false,
    }
    this.back = this.back.bind(this)
    this.next = this.next.bind(this)
    this.containerRef = React.createRef()
    this.slideRef = React.createRef()
    this.toggleSlidePopupInfo = this.toggleSlidePopupInfo.bind(this)
    this.onMouseLeaveLink = this.onMouseLeaveLink.bind(this)
    this.onMouseEnterLink = this.onMouseEnterLink.bind(this)
    this.onMouseLeaveInfo = this.onMouseLeaveInfo.bind(this)
    this.onMouseEnterInfo = this.onMouseEnterInfo.bind(this)
    this.onMouseLeaveSlide = this.onMouseLeaveSlide.bind(this)
    this.onMouseEnterSlide = this.onMouseEnterSlide.bind(this)
    this.onMouseOverSlide = this.onMouseOverSlide.bind(this)
  }

  updateHeight = () => {
    if (window.innerHeight) {
      this.setState({
        innerH: window.innerHeight,
      })
    }
  }

  updateWidth = () => {
    if (window.innerWidth) {
      this.setState({
        innerW: window.innerWidth,
      })
    }
  }

  setFirstImageWidth = width => {
    this.setState({
      firstImageWidth: width,
      isHeaderSliderInfoReady: true,
    })
  }

  isHeaderSliderScrolled = () => {
    const el = document.getElementById('gallery-slider-header')
    const navHeight = 72
    if (window.pageYOffset <= navHeight) {
      this.setState({ isHeaderSliderScrolled: false })
    } else if (isBottom(el)) {
      this.setState({ isHeaderSliderScrolled: true })
    }
  }

  getHeaderSliderTogglePosition = () => {
    const slideIndex = this.props.slideIndex
    const el = document.querySelector(`[data-ref="header-slide-${slideIndex}-img"]`)
    if (el) {
      const wH = window.innerHeight || document.documentElement.clientHeight
      const elBottom = el.getBoundingClientRect().bottom
      const bottomPoint = elBottom + 72
      const aboveNav = bottomPoint >= wH
      let pos
      switch (true) {
        case aboveNav:
          pos = 'fixed'
          break
        default:
          pos = 'bottom'
      }
      this.setState({
        headerSliderTogglePosition: pos,
      })
    }
  }

  getArtistSliderTogglePosition = () => {
    const el = document.getElementById('gallery-slider-artist')
    const wH = window.innerHeight || document.documentElement.clientHeight
    if (el) {
      const elTop = el.getBoundingClientRect().top
      const elBottom = el.getBoundingClientRect().bottom
      const topPoint = elTop + 134
      const bottomPoint = elBottom - 32
      const belowNav = topPoint >= 0 && topPoint >= wH
      const fullyIn = fullyInViewport(el)
      const aboveNav = bottomPoint <= wH
      const underNav = !belowNav && !fullyIn && !aboveNav
      let pos
      switch (true) {
        case belowNav:
          pos = 'top'
          break
        case fullyIn:
          pos = 'bottom'
          break
        case aboveNav:
          pos = 'bottom'
          break
        case underNav:
          pos = 'fixed'
          break
        default:
          pos = 'bottom'
      }
      this.setState({
        artistSliderTogglePosition: pos,
      })
    }
  }

  initHeaderSliderScroll = () => {
    this.getHeaderSliderTogglePosition()
    this.isHeaderSliderScrolled()
  }

  initArtistSliderScroll = () => {
    const el = document.getElementById('gallery-slider-artist')
    if (el) {
      this.getArtistSliderTogglePosition()
    }
  }

  onScroll = () => {
    const { type } = this.props
    if (!isMobile) {
      if (type === 'header') {
        this.initHeaderSliderScroll()
      } else if (type === 'artist') {
        this.initArtistSliderScroll()
      }
    }
  }

  onResize = () => {
    if (!isMobile) {
      this.initHeaderSliderScroll()
    }
    this.updateHeaderInfoWidth()
  }

  // slider controls
  back(i) {
    const { type, slides } = this.props
    const lastIndex = slides.length - 1
    const negative = Math.sign(i - 1) === -1 || -0
    const prevIndex = negative ? lastIndex : i - 1
    this.slideRef.current.goBack()
    this.setState({
      slideIndex: prevIndex,
    })
    this.props.setSlideIndex(prevIndex)
  }

  next(i) {
    const { type, slides } = this.props
    const lastIndex = slides.length - 1
    const nextIndex = i + 1 <= lastIndex ? i + 1 : 0
    this.slideRef.current.goNext()
    this.setState({
      slideIndex: nextIndex,
    })
    this.props.setSlideIndex(nextIndex)
  }

  syncSlides() {
    if (this.state.slideIndex !== this.props.slideIndex) {
      this.slideRef.current.goTo(this.props.slideIndex)
      this.setState({
        slideIndex: this.props.slideIndex,
      })
    }
  }

  onSliderClick = (e, i, single, isMouseOverLink) => {
    const isMouseOverControls = document.body.classList.contains('is-mouse-over-video-controls')
    if (!single && !isMouseOverControls && !isMouseOverLink) {
      const tooltipArrowDirection = this.state.tooltipArrowDirection
      if (tooltipArrowDirection === 'right') {
        this.next(i)
      } else if (tooltipArrowDirection === 'left') {
        this.back(i)
      } else {
        this.next(i)
      }
    }
  }

  toggleSlidePopupInfo = () => {
    const { type } = this.props
    this.setState({
      isPopupInfoVisible: !this.state.isPopupInfoVisible,
    })
    if (type === 'header') {
      this.updateHeaderInfoWidth()
    }
  }

  setSlideImgLoad(i) {
    const slideIndex = this.state.slideIndex
    const lastIndex = this.props.slides.length - 1
    if (i === slideIndex) {
      return true
    } else if (i === slideIndex + 1) {
      return true
    } else if (i === slideIndex - 1) {
      return true
    } else if (i === 0 && slideIndex === lastIndex) {
      return true
    } else if (i === lastIndex && slideIndex === 0) {
      return true
    }
  }

  onOverlayToggleClick(i, isVideoPlayButton = false) {
    this.props.toggleOverlaySlider()
    if (isVideoPlayButton) {
      document.body.classList.add(`slide-${i}-video-init`)
    }
  }

  onVideoPlay = () => {
    if (this.state.isPopupInfoVisible) {
      this.setState({
        isPopupInfoVisible: false,
      })
    }
  }

  // info els offset
  updateInfoElsHeight(type) {
    const els = Array.from(document.getElementsByClassName(`gallery-slider__info--${type}`))
    if (!type === 'artist') {
      if (els && els.length) {
        const heights = els.map(el => el.scrollHeight)
        const highest = Math.max.apply(Math, heights)
        // const offset = type === 'artist' && isMobile ? 45 : 15
        const offset = 100
        els.forEach(el => {
          // const elH = el.firstChild.getBoundingClientRect().height
          // highest = elH > highest ? elH : highest
          el.style.height = `${highest * 2}px`
        })
      }
    }
  }

  updateHeaderInfoWidth() {
    const slides = document.querySelectorAll(`.gallery-slider__image-container--header`)
    slides.forEach(slide => {
      const width = isMobile ? slide.clientWidth : Math.floor(slide.clientWidth / 2)
      const infoEl = slide.querySelector(`.gallery-slider__popup-info-container`)
      if (infoEl) {
        infoEl.style.width = `${width}px`
      }
    })
  }

  // tooltip
  updateTooltipArrow(e) {
    e.preventDefault()
    const imgRect = e.currentTarget.getBoundingClientRect()
    const isOverlay = this.props.type === 'overlay'
    let halfWidth = isOverlay ? window.innerWidth / 2 : imgRect.width / 2
    let mouseX = isOverlay ? e.clientX : e.clientX - imgRect.left
    let pos
    switch (true) {
      case mouseX <= halfWidth:
        pos = 'left'
        break
      case mouseX > halfWidth:
        pos = 'right'
        break
      default:
        pos = undefined
    }
    this.setState({ tooltipArrowDirection: pos })
  }

  onMouseEnterSlide(e) {
    this.updateTooltipArrow(e)
    this.setState({ isMouseTooltipVisible: true, isMouseOverLink: false })
  }

  onMouseOverSlide(e) {
    this.updateTooltipArrow(e)
  }

  onMouseLeaveSlide() {
    this.setState({ isMouseTooltipVisible: false })
  }

  onMouseEnterLink() {
    this.setState({ isMouseOverLink: true, isMouseTooltipVisible: false })
  }

  onMouseLeaveLink() {
    this.setState({ isMouseOverLink: false, isMouseTooltipVisible: true })
  }

  onMouseEnterInfo() {
    this.setState({ isMouseOverLink: true, isMouseTooltipVisible: false })
  }

  onMouseLeaveInfo() {
    if (this.props.type === 'overlay') {
      this.setState({ isMouseOverLink: false, isMouseTooltipVisible: true })
    }
  }

  // renders
  renderBioLink(link) {
    const title = link.title && link.title.length ? link.title : 'Bio'
    if (link.artistReference) {
      const slug = link.artistReference.slug && link.artistReference.slug.current
      if (slug)
        return (
          <Link className="btn" to={`/artists/${slug}`}>
            {title}
          </Link>
        )
    } else {
      return (
        <a
          className="btn"
          href={link.download ? link.download.asset.url : link.externalLink}
          target="_blank"
          rel="noopener noreferrer"
          key={link._key}
        >
          {title}
        </a>
      )
    }
  }

  renderBodySliderLinks() {
    const { bioLinks, pressLinks, hasArticles, audio } = this.props
    const { bodySliderOffsetPadding } = this.state
    const multilineLinks = (pressLinks && pressLinks >= 3) || (bioLinks && bioLinks >= 3)
    return (
      <div
        className={`collaboration__links ${
          multilineLinks ? 'collaboration__links--multiline' : ''
        }`}
        style={{ paddingTop: `${bodySliderOffsetPadding}px` }}
      > 
        {bioLinks && bioLinks.map(link => this.renderBioLink(link))}
        {hasArticles ? (
          <Link className="btn" to="press">
            Press
          </Link>
        ) : (
          <></>
        )}
      </div>
    )
  }

  renderBodySliderInfoText = slideText => {
    return <div>{slideText && <PortableText blocks={slideText} />}</div>
  }

  renderSlideMobileOverlayInfo = slideText => {
    const classes = classNames({
      'is-info-text-visible': this.state.isPopupInfoVisible,
    })
    return (
      <div className={`gallery-slider__mobile-overlay-info ${classes}`}>
        <div className="gallery-slider__mobile-overlay-info-inner">
          <div className="gallery-slider__mobile-overlay-info-text">
            <div>{this.renderBodySliderInfoText(slideText)}</div>
          </div>
          <div className="gallery-slider__mobile-overlay-info-toggle">
            <button
              className="gallery-slider__popup-info-open btn icon-btn"
              onClick={this.toggleSlidePopupInfo}
              aria-label="Toggle gallery slider description text"
            >
              <InfoI />
            </button>
          </div>
        </div>
      </div>
    )
  }

  renderSlideMobileOverlayIndex = (i, length) => {
    return (
      <div>
        <button
          className="gallery-slider__overlay-index gallery-slider__overlay-index--mobile"
          onClick={this.toggleSlidePopupInfo}
          onMouseEnter={this.onMouseEnterLink}
          onMouseLeave={this.onMouseLeaveLink}
          aria-label="Toggle gallery slider info text"
        >
          {`${i + 1} / ${length}`}
        </button>
      </div>
    )
  }

  renderSlidePopupInfo = (i, length, isOverlay, slideText, framed) => {
    const { slideIndex } = this.props
    const overlayClasses = classNames({
      'is-info-text-visible': this.state.isPopupInfoVisible,
      'is-info-text-empty': !slideText,
    })
    let infoW = `100%`
    const imgEl = document.querySelector(
      `[data-ref="${isOverlay ? 'overlay' : 'header'}-slide-${slideIndex}-img"]`
    )
    if (imgEl) {
      infoW = Math.floor(imgEl.width / 3)
    }
    return (
      <div
        className={`gallery-slider__popup-info-container ${overlayClasses}`}
        onMouseEnter={this.state.isPopupInfoVisible ? this.onMouseEnterLink : undefined}
        onMouseLeave={this.onMouseLeaveLink}
        // style={!isOverlay ? { width: `${infoW}px` } : { width: '50%' }}
      >
        <button
          className={`gallery-slider__popup-info-open btn icon-btn ${
            framed ? '' : 'btn--bg-transparent'
          }`}
          onClick={this.toggleSlidePopupInfo}
          onMouseEnter={this.onMouseEnterLink}
          onMouseLeave={!this.state.isPopupInfoVisible ? this.onMouseLeaveLink : undefined}
          aria-label="Toggle gallery slider info text"
        >
          <InfoI />
        </button>
        {isOverlay && length > 1 && (
          <button
            className="gallery-slider__overlay-index"
            // onClick={this.toggleSlidePopupInfo}
            onMouseEnter={this.onMouseEnterLink}
            onMouseLeave={this.onMouseLeaveLink}
            aria-label="Gallery slider index"
          >
            {`${i + 1} / ${length}`}
          </button>
        )}
        <button
          className={`gallery-slider__popup-info`}
          onClick={this.toggleSlidePopupInfo}
          onMouseEnter={this.onMouseEnterLink}
          onMouseLeave={this.onMouseLeaveLink}
          aria-label="Toggle gallery slider info text"
        >
          {this.renderBodySliderInfoText(slideText)}
        </button>
      </div>
    )
  }

  renderBodySliderInfo = (i, slideText) => {
    const { slideIndex, firstImageWidth } = this.state
    const { type } = this.props
    const imgEl = document.querySelector(`[data-ref="${type}-slide-${slideIndex}-img"]`)
    let infoW = `100%`
    if (imgEl) {
      infoW = `${imgEl.width === 0 ? `${firstImageWidth}px` : imgEl.width + 'px'}`
    }

    return (
      <>
        <div
          className={`gallery-slider__info gallery-slider__info--${type} ${
            this.state.isHeaderSliderInfoReady ? 'is-ready' : ''
          }`}
          onMouseEnter={this.onMouseEnterInfo}
          onMouseMove={this.onMouseOverInfo}
          onMouseLeave={this.onMouseLeaveInfo}
          data-ref={`${type}-slide-${i}-info`}
          style={{ width: `${infoW}` }}
        >
          {this.renderBodySliderInfoText(slideText)}
        </div>
      </>
    )
  }

  render() {
    const { type, slides, noOverlay } = this.props
    const {
      isMouseOverLink,
      isSlideInfoIn,
      headerSliderTogglePosition,
      artistSliderTogglePosition,
    } = this.state
    const sliderSettings = {
      duration: 3000,
      transitionDuration: 500,
      infinite: true,
      arrows: false,
      easing: 'ease',
      autoplay: false,
    }
    const single = slides && slides.length === 1
    const isHeader = type === 'header'
    const isBody = type === 'body'
    const isOverlay = type === 'overlay'
    const isArtist = type === 'artist'
    const isTeamMember = type === 'teamMember'
    const sliderClasses = classNames(
      {
        'gallery-slider--header': isHeader,
        'gallery-slider--body': isBody,
        'gallery-slider--overlay': isOverlay,
        'gallery-slider--artist': isArtist,
        'gallery-slider--team-member': isTeamMember,
        'gallery-slider--single-slide': single,
        'is-slide-info-in': isSlideInfoIn,
      },
      // `${isArtist ? 'is-artist-slider-toggle-' + artistSliderTogglePosition : ''}`,
      `${isHeader ? 'is-header-slider-toggle-' + headerSliderTogglePosition : ''}`
    )

    return (
      <>
        <div
          className={`gallery-slider slide-container ${sliderClasses} current-slide-${this.state.slideIndex}`}
          id={type ? `gallery-slider-${type}` : ''}
          data-current={this.state.slideIndex}
          ref={this.containerRef}
        >
          <div className="gallery-slider__inner">
            <Fade className="gallery-slider__carousel" ref={this.slideRef} {...sliderSettings}>
              {slides &&
                slides.map((slide, i) => {
                  const image = slide.image
                  const videoUrl = slide.videoUrl && slide.videoUrl.url
                  const slideText = slide.slideText
                  const slideIndexText = `Slide ${i + 1}/${slides.length}`
                  const genAltText = slideText && toPlainText(slideText)
                  const mainImage = slide.image.mainImage
                  const dimensions = image.mainImage.asset._rawMetadata.dimensions
                  const aspectRatio = dimensions.aspectRatio
                  const _innerW = isBrowser() ? window.innerWidth : 2400
                  const initialSrc =
                    mainImage && buildSliderSrcSetUrl(mainImage, _innerW, type, isMobile)
                  const tabletSrc =
                    mainImage && buildSliderSrcSetUrl(mainImage, 1024, type, isMobile)
                  const desktopSrc =
                    mainImage && buildSliderSrcSetUrl(mainImage, 1400, type, isMobile)
                  const widescreenSrc =
                    mainImage && buildSliderSrcSetUrl(mainImage, 1920, type, isMobile)
                  const XLSrc = mainImage && buildSliderSrcSetUrl(mainImage, 2400, type, isMobile)
                  const srcSet = `${tabletSrc} 1024w, ${desktopSrc} 1400w, ${widescreenSrc} 1920w, ${XLSrc} 2400w`
                  const isLandscape = aspectRatio && aspectRatio >= 1.1 // offset
                  const _framed = !image.fillSlide
                  const framed = isOverlay || isMobile ? _framed : true
                  const length = slides.length
                  const single = length === 1
                  const loadImg = isOverlay ? this.setSlideImgLoad(i) : true
                  const overlayStyle = {
                    height: `100%`,
                  }
                  const overlayImgContainerStyle = {
                    height: `100%`,
                  }
                  return (
                    <div
                      className={`each-fade ${this.setSlideImgLoad(i) ? 'load-img' : ''}`}
                      data-slide={i}
                      key={slide._key}
                    >
                      <div
                        className={`gallery-slider__slide gallery-slider__slide--${type} ${
                          framed ? 'is-image-framed' : ''
                        } ${videoUrl ? 'has-video' : ''}`}
                        style={isOverlay ? overlayStyle : {}}
                      >
                        {isOverlay && this.renderSlideMobileOverlayIndex(i, length)}
                        {/* overlay close btn */}
                        {isOverlay && (
                          <button
                            className={`gallery-slider__toggle gallery-slider__toggle--close btn icon-btn ${
                              framed && !isMobile ? '' : 'btn--bg-transparent'
                            }`}
                            onMouseEnter={this.onMouseEnterLink}
                            onMouseLeave={this.onMouseLeaveLink}
                            onClick={() => this.onOverlayToggleClick(i)}
                            data-ref={`${type}-slide-${i}-toggle`}
                            aria-label="Toggle full screen gallery slider"
                          >
                            <Open />
                          </button>
                        )}
                        <div
                          className={`gallery-slider__image-container gallery-slider__image-container--${type}`}
                          onClick={e => this.onSliderClick(e, i, single, isMouseOverLink)}
                          style={isOverlay ? overlayImgContainerStyle : {}}
                          onMouseEnter={isOverlay ? this.onMouseEnterSlide : undefined}
                          onMouseMove={isOverlay ? this.onMouseOverSlide : undefined}
                          onMouseLeave={this.onMouseLeaveSlide}
                          index={i}
                        >
                          <SliderImg
                            src={initialSrc}
                            srcSet={`${tabletSrc} 1024w, ${desktopSrc} 1400w, ${widescreenSrc} 1920w, ${XLSrc} 2400w`}
                            framed={framed}
                            classes={isLandscape ? 'is-landscape' : 'is-portrait'}
                            alt={
                              image.alt
                                ? `${slideIndexText}: ${image.alt}`
                                : genAltText
                                ? `${slideIndexText}: ${genAltText}`
                                : `${slideIndexText}`
                            }
                            onMouseEnter={!isOverlay ? this.onMouseEnterSlide : undefined}
                            onMouseMove={!isOverlay ? this.onMouseOverSlide : undefined}
                            onMouseLeave={!isOverlay ? this.onMouseLeaveSlide : undefined}
                            dataRef={`${type}-slide-${i}-img`}
                            loadImg={loadImg}
                            slideIndex={this.state.slideIndex}
                            setFirstImageWidth={this.setFirstImageWidth}
                            index={i}
                          />

                          {videoUrl && isOverlay && (
                            <SliderVideo url={videoUrl} index={i} onVideoPlay={this.onVideoPlay} />
                          )}
                          {/* video open play button*/}
                          {videoUrl && !isOverlay && !isMobile && (
                            <div className="gallery-slider__play-toggle-overlay">
                              <button
                                className="gallery-slider__play-toggle"
                                onClick={() => this.onOverlayToggleClick(i, true)}
                                onMouseEnter={this.onMouseEnterLink}
                                onMouseLeave={this.onMouseLeaveLink}
                                aria-label="Open gallery video slide in fullscreen"
                              >
                                <div className="gallery-slider__play-toggle-icon gallery-slider__play-toggle-icon--play">
                                  <Play />
                                </div>
                              </button>
                            </div>
                          )}
                          {isHeader &&
                            isBrowser() &&
                            this.renderSlidePopupInfo(i, length, isOverlay, slideText, framed)}
                          {isArtist &&
                            isBrowser() &&
                            this.renderSlidePopupInfo(i, length, isOverlay, slideText, framed)}
                          {/* overlay open btn */}
                          {!isOverlay && !noOverlay && (
                            <button
                              className={`gallery-slider__toggle gallery-slider__toggle--open btn icon-btn btn--bg-transparent`}
                              onMouseEnter={this.onMouseEnterLink}
                              onMouseLeave={this.onMouseLeaveLink}
                              onClick={() => this.onOverlayToggleClick(i)}
                              data-ref={`${type}-slide-${i}-toggle`}
                              aria-label="Toggle full screen gallery slider"
                            >
                              <Open />
                            </button>
                          )}
                        </div>
                        {isOverlay && this.renderSlideMobileOverlayInfo(slideText)}
                        {isOverlay &&
                          this.renderSlidePopupInfo(i, length, isOverlay, slideText, framed)}
                        {isBody && isBrowser() && this.renderBodySliderInfo(i, slideText)}
                        {isTeamMember && isBrowser() && this.renderBodySliderInfo(i, slideText)}
                        {!single && (
                          <MouseTooltip
                            offsetX={-17}
                            offsetY={-17}
                            visible={this.state.isMouseTooltipVisible}
                          >
                            <div className={`mouse-tooltip is-${this.state.tooltipArrowDirection}`}>
                              <ArrowNext />
                            </div>
                          </MouseTooltip>
                        )}
                      </div>
                      {isBody && this.renderBodySliderLinks()}
                    </div>
                  )
                })}
            </Fade>
          </div>
        </div>
      </>
    )
  }
  componentDidMount() {
    if (!isBrowser()) {
      return
    }
    const { type } = this.props
    document.addEventListener('scroll', this.onScroll)
    if (type === 'overlay') {
      // body scroll lock on
      this.targetElement = this.containerRef.current
      document.documentElement.style.overflow = 'hidden'
      disableBodyScroll(this.targetElement)
      setTimeout(() => {
        this.targetElement.classList.add('reveal-overlay-slides')
      }, 400)
    }
    if (type === 'header' || type === 'artist') {
      this.updateInfoElsHeight(type)
    }
    window.addEventListener('resize', e => {
      this.onResize()
    })
    document.addEventListener('DOMContentLoaded', function(event) {
      this.onResize()
    })
    this.onResize()
    this.syncSlides()
    this.updateHeight()
    this.updateWidth()
    this.onScroll()
    if (!isMobile) {
      this.initHeaderSliderScroll()
    }
  }
  componentDidUpdate() {
    this.syncSlides()
  }
  componentWillUnmount() {
    const { type } = this.props
    document.removeEventListener('scroll', this.onScroll)
    if (type === 'overlay') {
      // body scroll lock off
      clearAllBodyScrollLocks()
      document.documentElement.style.overflow = null
      // reset tooltip
      this.setState({
        isMouseOverImage: false,
        isMouseOverLink: false,
        isMouseTooltipVisible: null,
      })
    }
  }
}

export default GallerySlider
